import React from 'react';
import { PendingRows } from '../../Skeleton';
import WizardHeader from './WizardHeader';
import { Body, Footer, Shell } from './style';
import {
  StepPage as SetupPage,
  QuestionsColumn,
  StepHeading,
  H2,
  Sub,
} from './QuestionsStep/style';
import { MarkingColumn } from './MarkingStep/style';
import { SamplesHead, SamplesLayout } from './SamplesStep/style';
import { sampleIntro } from './SamplesStep/rules';
import { Header as ResultsHead, ResultsPage, Title } from './ResultsStep/style';
import { SETUP_STEP_COPY, STEP_LABELS } from './steps';
import { Page, Heading } from './ResponsesStep/style';
import { RESPONSES_COPY } from './ResponsesStep/copy';
import { StepPage, StepTitle, StepSub } from './YourMarksStep/style';

export default function ExamStepPending({ step }) {
  if (step === 'responses') {
    return (
      <Page aria-busy="true">
        <Heading>{RESPONSES_COPY.heading}</Heading>
        <PendingRows
          aria-label="Loading responses"
          style={{ minHeight: 296 }}
        />
      </Page>
    );
  }
  const title = STEP_LABELS[step];
  const rows = <PendingRows aria-label={title || 'Exam details'} />;
  if (step === 'questions' || step === 'marking') {
    const Column = step === 'questions' ? QuestionsColumn : MarkingColumn;
    const copy = SETUP_STEP_COPY[step];
    return (
      <SetupPage data-layout={step} aria-busy="true">
        <Column>
          <StepHeading>
            <H2>{copy.title}</H2>
            <Sub>{copy.sub}</Sub>
          </StepHeading>
          {rows}
        </Column>
      </SetupPage>
    );
  }
  if (step === 'results') {
    return (
      <ResultsPage aria-busy="true">
        <ResultsHead>
          <Title>{title}</Title>
        </ResultsHead>
        {rows}
      </ResultsPage>
    );
  }
  if (step === 'samples') {
    return (
      <SamplesLayout aria-busy="true">
        <SamplesHead>
          <div>
            <StepTitle>{title}</StepTitle>
            <StepSub>{sampleIntro()}</StepSub>
          </div>
        </SamplesHead>
        {rows}
      </SamplesLayout>
    );
  }
  return (
    <StepPage $entry={step === 'your-marks'} aria-busy="true">
      {title && <StepTitle>{title}</StepTitle>}
      {rows}
    </StepPage>
  );
}

export function ExamWizardPending({ step, onClose }) {
  return (
    <Shell aria-busy="true">
      <WizardHeader onClose={onClose} />
      <Body>
        <ExamStepPending step={step} />
      </Body>
      <Footer
        aria-hidden="true"
        style={{ minHeight: 64, boxSizing: 'border-box' }}
      />
    </Shell>
  );
}
